import { useAuth0 } from "@auth0/auth0-react";
import React, { createContext, useContext, useMemo } from "react";
import { useData } from "ee-react-components";
var UserPermissions = /** @class */ (function () {
    function UserPermissions(allPermissions, siteSpecificPermissions) {
        if (allPermissions === void 0) { allPermissions = new Set(); }
        if (siteSpecificPermissions === void 0) { siteSpecificPermissions = {}; }
        this.allPermissions = allPermissions;
        this.siteSpecificPermissions = siteSpecificPermissions;
    }
    UserPermissions.prototype.hasPermission = function (permission) {
        return this.allPermissions.has(permission);
    };
    UserPermissions.prototype.hasPermissionForSite = function (permission, siteId) {
        var _a, _b;
        return (_b = (_a = this.siteSpecificPermissions[siteId]) === null || _a === void 0 ? void 0 : _a.has(permission)) !== null && _b !== void 0 ? _b : false;
    };
    return UserPermissions;
}());
var PermissionsContext = createContext(new UserPermissions());
export var PermissionsProvider = function (_a) {
    var organizationId = _a.organizationId, children = _a.children;
    var _b = useAuth0(), isAuthenticated = _b.isAuthenticated, isLoading = _b.isLoading;
    var permissionsInfo = useData("".concat(process.env.CORE_SVC_URL, "/users/permissions/").concat(organizationId), !isLoading && isAuthenticated).data;
    var permissionsList = permissionsInfo === null || permissionsInfo === void 0 ? void 0 : permissionsInfo.permissions;
    var siteSpecificPermissions = {};
    for (var siteId in (permissionsInfo === null || permissionsInfo === void 0 ? void 0 : permissionsInfo.siteSpecificPermissions) || []) {
        siteSpecificPermissions[siteId] = new Set(permissionsInfo === null || permissionsInfo === void 0 ? void 0 : permissionsInfo.siteSpecificPermissions[siteId]);
    }
    var permissions = useMemo(function () {
        return new UserPermissions(permissionsList && permissionsList.length > 0
            ? new Set(permissionsList)
            : new Set([]), siteSpecificPermissions);
    }, [permissionsList, siteSpecificPermissions]);
    return (React.createElement(PermissionsContext.Provider, { value: permissions }, children));
};
export var usePermissions = function () { return useContext(PermissionsContext); };
